<template>
    <div>
        <b-modal id="modal-prevent-closing" class="header-modal" no-close-on-backdrop hide-footer
            ref="modal-create-learning-task">
            <div class="modal-create-poster__body container">
                <div class="filter-block">
                    <h3 class="tittle primary-color-txt font-sanpro-light">
                        <strong>Thêm nhiệm vụ học tập </strong><br />
                    </h3>
                    <div class="row margin-top-10">
                        <div class=" col-md-12">
                            <b-form-select @change="handleChangeClassId" v-model="paramQueryData.classId"
                                :options="listDataClass">
                            </b-form-select>
                        </div>
                        <!-- <div class="col-md-6">
                            <b-form-select @change="handleChangeSubjectId" v-model="paramQueryData.subjectId"
                                :options="listDataSubject">
                            </b-form-select>
                        </div> -->
                        <div class="col-md-12 custom-line margin-top-10">
                            <div class="line1">

                            </div>
                            <div class="text-line">
                                Tên
                            </div>
                            <div class="line1">

                            </div>
                        </div>
                    </div>

                    <div class="row " v-for="(item, index) of listUserLearningTaskLesson">
                        <div v-if="item.listChild.length > 0">
                            <div class="col-md-12 margin-top-5">
                                <div class="row">
                                    <div class="col-md-12 display-flex">
                                        <i class="icon-arrow-down icon-down margin-right-10"
                                            @click="handleToggerGroup(item)"></i>
                                        <b-form-checkbox v-if="item.countQuestion > 0"  @change="handleCheckbox($event, item)" class="float-right">
                                            <strong class="name-class" @click="handleToggerGroup(item)">
                                                {{item.name}}
                                            </strong>
                                        </b-form-checkbox>
                                        <strong v-else class="name-class" @click="handleToggerGroup(item)">
                                            {{item.name}}
                                        </strong>
                                    </div>
                                </div>

                            </div>
                            <div class="col-md-12">
                                <b-collapse id="collapse_filter" class="mt-2" :visible="item.isCollapse">
                                    <div class="row margin-left-30" v-for="(subItem, index) of item.listChild">
                                        <div v-if="subItem.listChild.length > 0">
                                            <div class="col-md-12 display-flex">
                                                <i class="icon-arrow-down icon-down margin-right-10"
                                                    @click="handleToggerGroup(subItem)"></i>
                                                <b-form-checkbox v-if="subItem.countQuestion > 0" @change="handleCheckbox($event, subItem)" class="float-right">
                                                    <strong class="name-class" @click="handleToggerGroup(subItem)">
                                                        {{ subItem.name }}
                                                    </strong>
                                                </b-form-checkbox>
                                                <strong v-else class="name-class" @click="handleToggerGroup(subItem)">
                                                    {{ subItem.name }}
                                                </strong>
                                            </div>
                                            <b-collapse id="collapse_filter" class="mt-2" :visible="subItem.isCollapse">
                                                <div class="row margin-left-45"
                                                    v-for="(subsubItem, index) of subItem.listChild">
                                                    <div class="col-md-12 display-flex">
                                                        <b-form-checkbox v-if="subsubItem.countQuestion > 0" class="float-right">
                                                            <strong @change="handleCheckbox($event, subsubItem)">
                                                                {{ subsubItem.name }}
                                                            </strong>
                                                        </b-form-checkbox>
                                                        <strong v-else @change="handleCheckbox($event, subsubItem)">
                                                            {{ subsubItem.name }}
                                                        </strong>
                                                    </div>


                                                </div>
                                            </b-collapse>
                                        </div>

                                        <div v-else>
                                            <div class="col-md-12 display-flex">
                                                <b-form-checkbox @change="handleCheckbox($event, subItem)"
                                                    class="float-right not-list-child"><strong>{{
                                subItem.name
                            }}</strong></b-form-checkbox>
                                            </div>
                                        </div>
                                    </div>


                                </b-collapse>

                            </div>
                        </div>
                        <div v-else>
                            <div class="col-md-12 margin-top-5 display-flex">
                                <b-form-checkbox @change="handleCheckbox($event, item)"
                                    class="float-right not-list-child"><strong>{{
                                        item.name
                                        }}</strong></b-form-checkbox>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="modal__actions text-right">
                    <a href="javascript:;" class="primary-color-txt font-size-17 btn-cancel"
                        @click="handleHideModal">Hủy
                        bỏ</a>
                    <a href="javascript:;" class="btn btn-err font-size-17 font-sanpro-semibold btn-create"
                        @click="handleSave">Thêm
                        mới</a>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { getAllTypeFilter, getAllClassFilter } from './../../../_api/'
import { getListUserLearningTaskLesson, saveLearningTask } from './../../../_api/learningTask'
export default {
    name: "ModalCreateLearningTask",
    props:{
        subjectId:{
            type:Number,
            default:0
        }
    },
    mounted() {
        this.getQueryParams()
        this.handleShowModal()
        this.GetAllClass()
        this.getListUserLearningTask()
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },

    },
    watch: {
        'paramQueryData.classId': 'getTypesFilter',
        'paramQueryData.keyword': 'handleSeach',


    },
    data() {
        return {
            isCollapse: false,
            isClick: false,
            listDataSubject: [{ value: 0, text: 'Môn học - Tất cả' },],
            listDataClass: [{ value: 0, text: 'Khối - Tất cả' },],
            listUserLearningTaskLesson: [],
            paramQueryData: {
                lessonClassSchoolId: 0,
                keyword: '',
                subjectId: this.subjectId,
                classId: 0,
                pageIndex: 1,
                pageSize: 999999,
                type: 2
            },

            listIDLearningTask: [],
        }
    },

    methods: {
        handleSave() {
            let self = this
            if(this.listIDLearningTask.length==0){
                this.$toast.error('Vui lòng chọn nhiệm vụ học tập')
                return
            }
            let data = {
                lessonClassSchoolId: this.paramQueryData.lessonClassSchoolId,
                listId: this.listIDLearningTask
            }
            saveLearningTask(data).then(res => {
                if (res && res.data && !res.errors) {
                    //thông báo
                    self.$toast.success('Thêm mới nhiệm vụ thành công')
                    self.handleDone()
                }

            })

        },
        handleSeach() {
            this.handleOnFilter()
        },
        handleChangeSubjectId(e) {
            this.handleOnFilter()
        },
        handleChangeClassId(e) {
            this.handleOnFilter()
        },
        handleOnFilter() {
            console.log(this.paramQueryData.subjectId)
            this.getListUserLearningTask()
        },

        handleDone() {
            this.$emit('handleDone')
            this.handleHideModal()
        },
        handleHideModal() {
            this.$emit('closeModal')
        },

        getQueryParams() {
            this.paramQueryData.lessonClassSchoolId = this.$route.query.id;
        },

        handleShowModal() {
            this.$refs['modal-create-learning-task'].show()
        },
        handleToggerGroup(item) {
            item.isCollapse = !item.isCollapse
        },
        handleCheckbox(isCheck, item) {
            if (isCheck) {
                this.listIDLearningTask.push(item.id)
            }
            else {
                for (let i = 0; i < this.listIDLearningTask.length; i++) {
                    const element = this.listIDLearningTask[i];
                    if (element == item.id) {
                        this.listIDLearningTask.splice(i, 1)
                        break
                    }
                }
            }
        },
        GetAllClass() {
            let self = this
            getAllClassFilter({}).then(res => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        if (item.name != 'Mầm non') {
                            self.listDataClass.push({ value: item.classId, text: item.name })
                        }
                    }
                }
            })
        },
        getTypesFilter() {
            let self = this
            self.listDataSubject = [{ value: 0, text: 'Môn học - Tất cả' },]
            this.subjectId = 0
            getAllTypeFilter({ classId: this.classId }).then(res => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.ltsSubject.length; i++) {
                        const item = res.data.ltsSubject[i];
                        self.listDataSubject.push({ value: item.subjectId, text: item.name })
                    }
                }
            })
        },

        getListUserLearningTask() {
            let self = this
            getListUserLearningTaskLesson(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listUserLearningTaskLesson = res.data.list;
                }

            })

        },

    }
}
</script>

<style lang="scss" scoped>
.input-custom-icon i {
    position: absolute;
    top: 0;
    right: 0;
    line-height: 30px;
    padding-right: 20px;
}

.margin-top-10 {
    margin-top: 10px;
    margin-bottom: 10px;
}

.over-flow-scroll {
    overflow: scroll;
    height: 100px;
}

.margin-top-5 {
    margin-top: 5px;
}

.margin-right-10 {
    margin-right: 10px;
}

.margin-left-15 {
    margin-left: 15px;
}

.margin-left-30 {
    margin-left: 30px;
}

.margin-left-45 {
    margin-left: 45px;
}

.modal__actions {

    .btn-cancel {
        margin-right: 20px;
        padding: 3px 20px;
        color: red;
    }

    .btn-create {
        border-radius: 15px;
        background-color: #0f3dba;
        color: white;
        border: none;
        padding: 3px 20px;
    }

}

.modal-create-poster__body {
    background-color: white;
}

.filter-keyword {
    padding-right: 30px !important;
}

.filter-btn {
    margin-left: 20px;
}

.filter__section__form {
    margin-top: 20px;

    .margin-left-10 {
        margin-left: 10px;
    }

    .min-width-100 {
        min-width: 100px;
    }
}

.filter_option_menu {
    flex-wrap: wrap;
}

.filter-block {
    padding: 0;
}

h3.tittle {
    margin: 15px 0;
}


.row {
    display: flex;
    flex-wrap: wrap;
}

.custom-line {
    display: flex;
    margin-top: 20px;
    padding-left: 20px;
    padding-right: 20px;

    .line1 {
        width: 100%;
        height: 2px;
        background: #e5e5e5;
    }

    .line2 {
        width: 100%;
        height: 2px;
        background: #e5e5e5;
    }

    .text-line {
        margin-top: -10px;
        padding-left: 10px;
        padding-right: 10px;
        color: #e5e5e5;
    }
}

.collapse {
    margin-bottom: 5px;
}

.custom-checkbox {
    margin-left: 2px;
}

.float-right {
    float: right;
}

.display-flex {
    display: flex;
    align-items: center;
}

.not-list-child {
    margin-left: 28px;
}
</style>